import Container from 'typedi';
import IHTTPClientAdapter from '../adapters/HTTPClientAdapter/IHTTPClientAdapter';
import BadRequestException from '../exceptions/BadRequestException';
import DocumentExistsException from '../exceptions/DocumentExistsException';
import { javaObjectNotationToJson } from '../utils/JsonUtils';

class RouteRepository {
  httpClientAdapter;
  lastmileApiUrl;
  constructor() {
    this.httpClientAdapter = Container.get(IHTTPClientAdapter);
    this.lastmileApiUrl = Container.get('ENV_LASTMILE_API_URL');
  }

  async getRoutes(page, rowsPerPage, filters) {
    try {
      let baseUrl = `${this.lastmileApiUrl}/route?pageNum=${page}&pageSize=${rowsPerPage}`;
      let filtersArray = [];
      if (filters) {
        if (filters.startDate) {
          filtersArray.push(`startDateFilter=${filters.startDate}`);
        }
        if (filters.endDate) {
          filtersArray.push(`endDateFilter=${filters.endDate}`);
        }
        if (filters.idOrigin && filters.idOrigin.length > 0) {
          for (const origin of filters.idOrigin) {
            filtersArray.push(`idsOriginFilter=${origin.id}`);
          }
        }
        if (filters.idsTag && filters.idsTag.length > 0) {
          for (const tag of filters.idsTag) {
            filtersArray.push(`idsTagFilter=${tag.id}`);
          }
        }
        if (filters.idDestination && filters.idDestination.length > 0) {
          for (const destination of filters.idDestination) {
            filtersArray.push(`idsDestinationFilter=${destination.id}`);
          }
        }
        if (filters.idStatus && filters.idStatus.length > 0) {
          for (const status of filters.idStatus) {
            filtersArray.push(`idsStatusFilter=${status.id}`);
          }
        }
        if (filters.name) {
          filtersArray.push(`nameFilter=${filters.name}`);
        }
        if (filters.extraData) {
          filtersArray.push(`extraData=${filters.extraData}`);
        }
        if (filters.documentNumber) {
          filtersArray.push(`numberDocument=${filters.documentNumber}`);
        }
        if (filters.routeId) {
          filtersArray.push(`idFilter=${filters.routeId}`);
        }
        if (filters.driver && filters.driver.length > 0) {
          for (const driver of filters.driver) {
            filtersArray.push(`idsOperadorFilter=${driver.id}`);
          }
        }
        if (filters.vehicle && filters.vehicle.length > 0) {
          for (const vehicle of filters.vehicle) {
            filtersArray.push(`idVehiclesFilter=${vehicle.id}`);
          }
        }
      }
      const filterQuery = filtersArray.join('&');
      const url = baseUrl + (filterQuery.length ? `&${filterQuery}` : '');
      const clientId = Container.get('clientId');
      const accessToken = Container.get('accessToken');
      const apiKey = Container.get('apiKey');

      const config = {
        headers: {
          'id-client': clientId,
          Authorization: `Bearer ${accessToken}`,
          'x-api-key': apiKey,
        }
      };
      return await this.httpClientAdapter.get(url, config);
    } catch (e) {
      console.log(e);
      return {
        data: [],
        paginator: {
          totalRows: 0,
        },
      };
    }
  }
  async sendMassiveRouteSubmission(requestBody) {
    let response = null;
    let messageResponse = null;
    try {
      const clientId = Container.get('clientId');
      const accessToken = Container.get('accessToken');
      const apiKey = Container.get('apiKey');
      const url = `${this.lastmileApiUrl}/api/createMassiveRoute/request?externalUser=false`;
      const headers = {
        'Content-Type': 'application/json',
        'id-client': clientId,
        Authorization: 'Bearer ' + accessToken,
        'x-api-key': apiKey,
      };
      response = await this.httpClientAdapter.post(url, requestBody, headers);
    } catch (e) {
      if (e instanceof BadRequestException) {
        const responseObject = e.message;
        const respuesta = javaObjectNotationToJson(responseObject.toString());
        const matches = respuesta.message.match(/Ha ocurido un error: Document number (.*) already exists/);
        if (matches.length > 1) {
          throw new DocumentExistsException(respuesta, matches[1]);
        } else {
          throw new Error(e.message);
        }
      } else {
        throw new Error(e.message);
      }
    }

    let result = {
      status: null,
      message: null,
    };

    if (response != null) {
      let statusResponse = await this.checkStatus(response.executionId);

      await new Promise((r) => setTimeout(r, 3000));
      let counter = 1;

      let failCounter = 0;
      while (statusResponse === 'notReady' && failCounter < 60) {
        console.log(statusResponse);

        statusResponse = await this.checkStatus(response.executionId);
        await new Promise((r) => setTimeout(r, 3000));
        failCounter++;
      }

      if (failCounter === 60) {
        throw new Error('Tiempo de espera excedido');
      }

      while (statusResponse.phase !== 'DONE' && statusResponse.phase !== 'FAIL' && counter < 60) {
        statusResponse = await this.checkStatus(response.executionId);
        counter++;
        await new Promise((r) => setTimeout(r, 3000));
      }

      if (counter >= 60) {
        result.status = 'FAIL';
        result.message = 'timeout';
        return result;
      }

      if (statusResponse.phase === 'DONE') {
        result.status = 'DONE';
        return result;
      } else {
        messageResponse = statusResponse;
        result.status = 'FAIL';
        result.message = messageResponse.message;
        return result;
      }
    } else {
      result.status = 'FAIL';
      result.message = 'noResponse';
      return result;
    }
  }
  async checkStatus(executionId) {
    try {
      const clientId = Container.get('clientId');
      const accessToken = Container.get('accessToken');
      // const apiKey = Container.get('apiKey');
      const url = `${this.lastmileApiUrl}/api/createMassiveRoute/checkStatus/${executionId}`;
      const config = {
        headers: {
          'id-client': clientId,
          Authorization: `Bearer ${accessToken}`,
        }
      };
      return await this.httpClientAdapter.get(url, config);
    } catch (e) {
      return 'notReady';
    }
  }
  async getStatus() {
    const clientId = Container.get('clientId');
    const accessToken = Container.get('accessToken');
    const url = `${this.lastmileApiUrl}/statusRoute`;
    try {
      const config = {
        headers: {
          'id-client': clientId,
          Authorization: `Bearer ${accessToken}`,
        }
      };
      const response = await this.httpClientAdapter.get(url, config);
      return response.data;
    } catch (e) {
      return [];
    }
  }

  async deleteRoute(id) {
    const clientId = Container.get('clientId');
    const accessToken = Container.get('accessToken');
    const url = `${this.lastmileApiUrl}/route/${id}`;
    try {
      const response = await this.httpClientAdapter.delete(url, {
        'id-client': clientId,
        Authorization: `Bearer ${accessToken}`,
      });
      return response.data;
    } catch (e) {
      return [];
    }
  }

  async getRouteById(id) {
    const clientId = Container.get('clientId');
    const accessToken = Container.get('accessToken');
    const url = `${this.lastmileApiUrl}/route/${id}`;
    try {
      const config = {
        headers: {
          'id-client': clientId,
          Authorization: `Bearer ${accessToken}`,
        }
      };
      const response = await this.httpClientAdapter.get(url, config);
      return response.data;
    } catch (e) {
      return [];
    }
  }
}

Container.set({ id: RouteRepository, type: RouteRepository });

export default RouteRepository;
